import { createSelector } from "reselect";

import { makeSelectSfColumns } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/salesforce/exportSelectors";
import type { ExportName } from "app/pages/sales-intelligence/sub-modules/management/store/type";
import type { CrmColumnItem } from "app/pages/sales-intelligence/sub-modules/management/types";
import type { RootState } from "single-spa/store/types";

import { createCrmFieldOptionsSelector, selectSelectedJobObject } from "../../../store/selectors";
import type { CrmEnrichmentJobObject } from "../../../types/types";
import { ENRICHMENT_OBJECT_TO_EXPORT_NAME } from "../../../utils/enrichmentObjectToExportName";

const DEFAULT_COLUMNS: readonly CrmColumnItem[] = [];

export const selectSfColumnsByJobObject = (state: RootState, jobObject?: CrmEnrichmentJobObject) => {
    if (!jobObject) {
        return DEFAULT_COLUMNS;
    }

    return makeSelectSfColumns(ENRICHMENT_OBJECT_TO_EXPORT_NAME[jobObject])(state);
};

export const selectSfColumnsBySelectedJobObject = createSelector(
    [selectSelectedJobObject, (state: RootState) => state],
    (selectedJobObject, state) => {
        if (!selectedJobObject) {
            return DEFAULT_COLUMNS;
        }

        return selectSfColumnsByJobObject(state, selectedJobObject);
    },
);

export const selectSfCrmFieldOptions = createCrmFieldOptionsSelector(selectSfColumnsBySelectedJobObject);
